// ===== Mueblika · Filtro instantáneo del blog =====
// Al hacer clic en una etiqueta, muestra/oculta las tarjetas sin
// recargar la página, comparando contra las etiquetas (handleized)
// que cada tarjeta lleva en su atributo data-mbk-tags.

(function () {
  document.addEventListener('DOMContentLoaded', function () {
    const filtersWrap = document.querySelector('[data-mbk-blog-filters]');
    const grid = document.querySelector('[data-mbk-blog-grid]');
    const emptyMsg = document.querySelector('[data-mbk-blog-empty]');
    if (!filtersWrap || !grid) return;

    const filterButtons = filtersWrap.querySelectorAll('[data-mbk-filter]');
    const items = grid.querySelectorAll('[data-mbk-blog-item]');

    filterButtons.forEach((btn) => {
      btn.addEventListener('click', () => {
        const filter = btn.dataset.mbkFilter;

        filterButtons.forEach((b) => b.classList.remove('is-active'));
        btn.classList.add('is-active');

        let visibleCount = 0;

        items.forEach((item) => {
          const tags = (item.dataset.mbkTags || '').split(' ');
          const show = filter === 'todos' || tags.includes(filter);
          item.style.display = show ? '' : 'none';
          if (show) visibleCount += 1;
        });

        if (emptyMsg) emptyMsg.hidden = visibleCount > 0;
      });
    });
  });
})();